import { render, staticRenderFns } from "./main-container.vue?vue&type=template&id=326f835e&scoped=true&"
import script from "./main-container.vue?vue&type=script&lang=js&"
export * from "./main-container.vue?vue&type=script&lang=js&"
import style0 from "./main-container.vue?vue&type=style&index=0&id=326f835e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f835e",
  null
  
)

export default component.exports